import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = (language: string) => {
    // Get current path without language prefix
    const currentPath = location.pathname;
    const segments = currentPath.split('/').filter(Boolean);
    
    // Remove language prefix if it exists
    if (segments[0] && ['es', 'en'].includes(segments[0])) {
      segments.shift();
    }
    
    // Create new path with new language
    const newPath = `/${language}/${segments.join('/')}`;
    
    // Update i18n language
    i18n.changeLanguage(language);
    
    // Navigate to new URL
    navigate(newPath);
  };

  const getCurrentLanguage = () => {
    return i18n.language;
  };

  const isLanguage = (language: string) => {
    return i18n.language === language;
  };

  const getPathWithoutLanguage = () => {
    const currentPath = location.pathname;
    const segments = currentPath.split('/').filter(Boolean);
    
    // Remove language prefix if it exists
    if (segments[0] && ['es', 'en'].includes(segments[0])) {
      segments.shift();
    }
    
    return `/${segments.join('/')}`;
  };

  const getPathWithLanguage = (path: string, language?: string) => {
    const lang = language || i18n.language;
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `/${lang}/${cleanPath}`;
  };

  return {
    t,
    i18n,
    changeLanguage,
    getCurrentLanguage,
    isLanguage,
    currentLanguage: i18n.language,
    getPathWithoutLanguage,
    getPathWithLanguage
  };
};

export default useTranslation;
